import router from './router'
import store from './store'
import {
  Message
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
  getToken
} from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist
const visitedViews = store.state.tagsView.visitedViews

router.beforeEach(async(to, from, next) => {
  // debugger
  // start progress bar
  const visitedViewsArr = visitedViews.map(v => v.path)
  if (!visitedViewsArr.includes(to.path)) {
    NProgress.start()
  }

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({
        path: '/'
      })
      // NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // 确定用户是否已通过getInfo获得其权限角色

      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      // hasRoles=true
      if (hasRoles) {
        next()
      } else {
        // 或者说还有一种姐  例如：[‘admin’]或，[‘developer’，‘ditor’]   后端给了个接口可以查询这个
        try {
          // get user info
          // 注意：角色必须是一个对象数组！例如：[‘admin’]或，[‘developer’，‘ditor’]
          // const { roles } = await store.dispatch('user/getInfo')

          const {
            userName
          } = await store.dispatch('user/getInfo')
          // const userName = 'admin';
          // let roles = [];
          // roles.push(userName);
          // 基于角色生成可访问
          const accessRoutes = await store.dispatch(
            'permission/leftList',
            store.getters.roles
          )
          // const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
          // accessRoutes就是计算出来的需要权限访问的路由
          // 动态添加可访问的路由
          // console.log(accessRoutes,'66666666666666666');
          // router.options.routes.push(...accessRoutes)
          router.addRoutes(accessRoutes)
          // window.reload()

          // 确保addRoutes完整的破解方法
          // 设置replace:true，这样导航就不会留下历史记录
          // console.log(accessRoutes, 111);

          if (to.path.includes('dashboard') && accessRoutes.filter(v => v.path.includes('home')).length) {
            next({
              ...to,
              replace: true
            })
          } else {
            next({
              // path: router.match(to.path) ? to.path : accessRoutes[0].path,
              path: accessRoutes[0].path,
              replace: true
            })
          }
          // router.push(to.path)
        } catch (error) {
          // 删除令牌并转到登录页面重新登录
          await store.dispatch('user/resetToken')
          // Message.error（错误||“有错误”）
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免费登录白名单中，直接进入
      next()
    } else {
      // 其他没有访问权限的页面被重定向到登录页面。
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
